/* OC2 a11y patch: decorative SVGs + form labeling for well-formed a11y tree */
(function(){
  function fix(){
    document.querySelectorAll('svg').forEach(function(s){
      if (s.closest('a,button') || s.getAttribute('aria-label') || s.getAttribute('role') === 'img') {
        if (!s.getAttribute('aria-hidden') && !s.getAttribute('aria-label') && !s.querySelector('title')) s.setAttribute('aria-hidden','true');
        return;
      }
      if (!s.getAttribute('aria-label') && !s.querySelector('title') && s.getAttribute('role') !== 'img') s.setAttribute('aria-hidden','true');
    });
    document.querySelectorAll('form:not([aria-label])').forEach(function(f, i){
      var sec = f.closest('.shopify-section, section');
      var h = sec && sec.querySelector('h1,h2,h3,.field__label,label');
      var name = (h && h.textContent.trim().slice(0,60)) || f.getAttribute('class') || '';
      if (/search/i.test(f.className)) f.setAttribute('aria-label','Search');
      else if (/cart/i.test(f.className)) f.setAttribute('aria-label','Cart quantity update');
      else if (name) f.setAttribute('aria-label', name + ' form');
      else f.setAttribute('aria-label','Form ' + (i+1));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix); else fix();
})();
